export const caProvinces =
  [
    'NL',
    'PE',
    'NS',
    'NB' ,
    'QC',
    'ON',
    'MB',
    'SK',
    'AB',
    'BC',
    'YT',
    'NT',
    'NU',
  ];
